/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'

import store from '../store'

function route(path, view, name, meta = {}, props = false) {
	const route = {
		name: name || view,
		props,
		path,
		component: (resovle) => import(`@/views/${view}.vue`).then(resovle),
		meta: meta || {},
	}

	return route
}

Vue.use(Router)

// Create a new routerfrr
const router = new Router({
	mode: 'history',
	routes: paths.map(path => route(path.path, path.view, path.name, path.meta, path.props)).concat([
		{ path: '*', redirect: '/' },
	]),
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		if (to.hash) {
			return { selector: to.hash }
		}
		return { x: 0, y: 0 }
	},
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (store.getters['auth/authenticated']) {
			next();
		} else {
			next('/login');
		}
	} else {
		next()
	}
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresGuest)) {
		if (store.getters['auth/authenticated']) {
			next('/');
		} else {
			next();
		}
	} else {
		next()
	}
});

router.beforeEach((to, from, next) => {
	store.commit('app/setRouteLoading', true);
	next();
});
router.afterEach((to, from) => {
	store.commit('app/setRouteLoading', false);
});
router.onError(error => {
	store.commit('app/setRouteLoading', false);
	console.error(error)
});

/**
 * Проверка токена перед переходом
 */
const waitForTokenChecking = (to, from, next) => {
	function proceed() {
		if (!store.state.auth.checkingToken) {
			next()
		}
	}

	if (store.state.auth.checkingToken) {
		store.watch(
			(state) => state.auth.checkingToken,
			(value) => {
				if (value === false) {
					proceed()
				}
			}
		)
	} else {
		proceed()
	}
};
router.beforeEach(waitForTokenChecking);

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
	Vue.use(VueAnalytics, {
		id: process.env.GOOGLE_ANALYTICS,
		router,
		autoTracking: {
			page: process.env.NODE_ENV !== 'development',
		},
	})
}

export default router
